import { 
    AP_CHANNEL_INFO_5GH_API_REQUEST,
    AP_CHANNEL_INFO_5GH_API_SUCCESS,
    AP_CHANNEL_INFO_5GH_API_FAIL,
    AP_CHANNEL_INFO_2GH_API_REQUEST,
    AP_CHANNEL_INFO_2GH_API_SUCCESS,
    AP_CHANNEL_INFO_2GH_API_FAIL,
    AP_CHANNEL_UTILIZATION_2GH_API_REQUEST,
    AP_CHANNEL_UTILIZATION_2GH_API_SUCCESS,
    AP_CHANNEL_UTILIZATION_2GH_API_FAIL,
    AP_CHANNEL_UTILIZATION_5GH_API_REQUEST,
    AP_CHANNEL_UTILIZATION_5GH_API_SUCCESS,
    AP_CHANNEL_UTILIZATION_5GH_API_FAIL,
    AP_CHANNEL_EXTENSION_24GH_API_REQUEST,
    AP_CHANNEL_EXTENSION_24GH_API_SUCCESS,
    AP_CHANNEL_EXTENSION_24GH_API_FAIL,
    AP_CHANNEL_EXTENSION_5GH_API_REQUEST,
    AP_CHANNEL_EXTENSION_5GH_API_SUCCESS,
    AP_CHANNEL_EXTENSION_5GH_API_FAIL,
    AP_ROGUE_24GH_API_REQUEST,
    AP_ROGUE_24GH_API_SUCCESS,
    AP_ROGUE_24GH_API_FAIL,
    AP_ROGUE_5GH_API_REQUEST,
    AP_ROGUE_5GH_API_SUCCESS,
    AP_ROGUE_5GH_API_FAIL
   } from "../../constants/graphConstants/apDashboardConstants";
  import { SAVE_AP_GRAPH_WIDGET} from '../../constants/accessPointConstants';

   export const apDashboardReducer = (
       state = { 
           channelInfo2 : {
               graphData : {},
               apiLoading: false,
               apiError: null
           },
           channelInfo5 : {
                graphData : {},
                apiLoading: false,
                apiError: null
            },
            channelUtilisation2 : {
                graphData : [],
                apiLoading: false,
                apiError: null
            },  
            channelUtilisation5 : {
                graphData : [],
                apiLoading: false,
                apiError: null
            },
            channelExtension24: {
                graphData : {},
                apiLoading: false,
                apiError: null
            } , 
            channelExtension5: {
                graphData : {},
                apiLoading: false,
                apiError: null
            },  
            channelRogue24: {
                graphData : {},
                apiLoading: false,
                apiError: null
            } , 
            channelRogue5: {
                graphData : {},
                apiLoading: false,
                apiError: null
            },
            apGraphWidget : {
                graphList : [],
                latestGraphName : null
            }  
        },
       action
    ) => {
      switch (action.type) {
        case AP_CHANNEL_INFO_2GH_API_REQUEST:
            return {
                ...state,
                channelInfo2: {
                    ...state.channelInfo2,
                    graphData : {},
                    apiLoading: true,
                    apiError: null
                }
            };
        case AP_CHANNEL_INFO_2GH_API_SUCCESS:
            return {
                ...state,
                channelInfo2: {
                    ...state.channelInfo2,
                    graphData : action.payload,
                    apiLoading: false,
                    apiError: null
                }
            };
        case AP_CHANNEL_INFO_2GH_API_FAIL:
            return {
                ...state,
                channelInfo2: {
                    ...state.channelInfo2,
                    graphData : {},
                    apiLoading: false,
                    apiError: action.payload
                }
            };
        case AP_CHANNEL_INFO_5GH_API_REQUEST:
            return {
                ...state,
                channelInfo5: {
                    ...state.channelInfo5,
                    graphData : {},
                    apiLoading: true,
                    apiError: null
                }
            };
        case AP_CHANNEL_INFO_5GH_API_SUCCESS:
            return {
                ...state,
                channelInfo5: {
                    ...state.channelInfo5,
                    graphData : action.payload,
                    apiLoading: false,
                    apiError: null
                }
            };
        case AP_CHANNEL_INFO_5GH_API_FAIL:
            return {
                ...state,
                channelInfo5: {
                    ...state.channelInfo5,
                    graphData : {},
                    apiLoading: false,
                    apiError: action.payload
                }
            };
        case AP_CHANNEL_UTILIZATION_2GH_API_REQUEST:
            return {
                ...state,
                channelUtilisation2: {
                    ...state.channelUtilisation2,
                    graphData : [],
                    apiLoading: true,
                    apiError: null
                }
            };
        case AP_CHANNEL_UTILIZATION_2GH_API_SUCCESS:
            return {
                ...state,
                channelUtilisation2: {
                    ...state.channelUtilisation2,
                    graphData : action.payload,
                    apiLoading: false,
                    apiError: null
                }
            };
        case AP_CHANNEL_UTILIZATION_2GH_API_FAIL:
            return {
                ...state,
                channelUtilisation2: {
                    ...state.channelUtilisation2,
                    graphData : [],
                    apiLoading: false,
                    apiError: action.payload
                }
            };

        case AP_CHANNEL_UTILIZATION_5GH_API_REQUEST:
            return {
                ...state,
                channelUtilisation5: {
                    ...state.channelUtilisation5,
                    graphData : [],
                    apiLoading: true,
                    apiError: null
                }
            };
        case AP_CHANNEL_UTILIZATION_5GH_API_SUCCESS:
            return {
                ...state,
                channelUtilisation5: {
                    ...state.channelUtilisation5,
                    graphData : action.payload,
                    apiLoading: false,
                    apiError: null
                }
            };
        case AP_CHANNEL_UTILIZATION_5GH_API_FAIL:
            return {
                ...state,
                channelUtilisation5: {
                    ...state.channelUtilisation5,
                    graphData : [],
                    apiLoading: false,
                    apiError: action.payload
                }
            };
        case AP_CHANNEL_EXTENSION_24GH_API_REQUEST:
            return {
                ...state,
                channelExtension24: {
                    ...state.channelExtension24,
                    graphData : {},
                    apiLoading: true,
                    apiError: null
                }
            };
        case AP_CHANNEL_EXTENSION_24GH_API_SUCCESS:
            return {
                ...state,
                channelExtension24: {
                    ...state.channelExtension24,
                    graphData : action.payload,
                    apiLoading: false,
                    apiError: null
                }
            };
        case AP_CHANNEL_EXTENSION_24GH_API_FAIL:
            return {
                ...state,
                channelExtension24: {
                    ...state.channelExtension24,
                    graphData : {},
                    apiLoading: false,
                    apiError: action.payload
                }
            };
        case AP_CHANNEL_EXTENSION_5GH_API_REQUEST:
            return {
                ...state,
                channelExtension5: {
                    ...state.channelExtension5,
                    graphData : {},
                    apiLoading: true,
                    apiError: null
                }
            };
        case AP_CHANNEL_EXTENSION_5GH_API_SUCCESS:
            return {
                ...state,
                channelExtension5: {
                    ...state.channelExtension5,
                    graphData : action.payload,
                    apiLoading: false,
                    apiError: null
                }
            };
        case AP_CHANNEL_EXTENSION_5GH_API_FAIL:
            return {
                ...state,
                channelExtension5: {
                    ...state.channelExtension5,
                    graphData : {},
                    apiLoading: false,
                    apiError: action.payload
                }
            };
        
        case AP_ROGUE_24GH_API_REQUEST:
            return {
                ...state,
                channelRogue24: {
                    ...state.channelRogue24,
                    graphData : {},
                    apiLoading: true,
                    apiError: null
                }
            };
        case AP_ROGUE_24GH_API_SUCCESS:
            return {
                ...state,
                channelRogue24: {
                    ...state.channelRogue24,
                    graphData : action.payload,
                    apiLoading: false,
                    apiError: null
                }
            };
        case AP_ROGUE_24GH_API_FAIL:
            return {
                ...state,
                channelRogue24: {
                    ...state.channelRogue24,
                    graphData : {},
                    apiLoading: false,
                    apiError: action.payload
                }
            };
        case AP_ROGUE_5GH_API_REQUEST:
            return {
                ...state,
                channelRogue5: {
                    ...state.channelRogue5,
                    graphData : {},
                    apiLoading: true,
                    apiError: null
                }
            };
        case AP_ROGUE_5GH_API_SUCCESS:
            return {
                ...state,
                channelRogue5: {
                    ...state.channelRogue5,
                    graphData : action.payload,
                    apiLoading: false,
                    apiError: null
                }
            };
        case AP_ROGUE_5GH_API_FAIL:
            return {
                ...state,
                channelRogue5: {
                    ...state.channelRogue5,
                    graphData : {},
                    apiLoading: false,
                    apiError: action.payload
                }
            };
        case SAVE_AP_GRAPH_WIDGET:
            return {
                ...state,
                apGraphWidget: {
                   ...action.payload
                }
            };
        default:
            return state;
        }
   }